<template>
  <div>
    <div class="auto">
      <page-title title="短链接" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="handle" class="el-icon-plus" size="small"> 添加短链接</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-input v-model="filter.search" size="small" clearable class="m-lr-5" style="width:200px;" placeholder="搜索名称"><i class="el-icon-search el-input__icon" slot="suffix"></i></el-input>
              <el-button type="primary" size="small" @click="handleChangeFilter()">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="long_url" label="原始链接"></el-table-column>
            <el-table-column prop="short_url" label="短链接"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <!-- <el-table-column label="操作" width="275">
              <template slot-scope="scope">
                <el-button
                  @click="handle(scope.row)"
                  type="primary"
                  size="small">
                  修改配置
                </el-button>
                <el-button
                  @click="qrcodeHandle(scope.row)"
                  type="primary"
                  size="small">
                  查看二维码
                </el-button>
                <el-button
                  @click="downloadHandle(scope.row)"
                  type="primary"
                  size="small">
                  下载
                </el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加短链接" :modal-append-to-body="false" :visible.sync="dialogVisible">
      <el-form ref="form" :rules="rules" :model="form" label-width="100px" size="small" v-loading="submitloading">
        <el-form-item prop="name" label="名称">
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="long_url" label="链接">
          <el-input v-model.trim="form.long_url"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import { Mp } from '@/model'
import Config from '@/conf'
export default {
  data () {
    return {
      dialogVisible: false,
      submitloading: false,
      tableData: [],
      form: {
        name: '',
        long_url: ''
      },
      rules: {
        name: [
          { required: true, message: '名称不能为空！', trigger: 'blur' }
        ],
        long_url: [
          { required: true, message: '链接不能为空！', trigger: 'blur' }
        ]
      },
      loading: false,
      formClone: {
        name: '',
        long_url: ''
      },
      total: 0,
      filter: {
        search: '',
        page: '1',
        limit: '10'
      }
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        search: '',
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/system/shorturl', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getUrlList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    handle (row) {
      if (row) {
        row = {
          qrcode_id: row['qrcode_id'],
          name: row['name'],
          tag_ids: row['tag_list'] || [],
          remark: row['remark']
        }
      } else {
        row = Object.assign({}, this.formClone)
      }
      this.form = row
      this.dialogVisible = true
    },
    handleSubmit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.submitloading = true
          let result = await Mp.System.ShortUrlDoSubmit(this.form)
          if (result && !result['err_code']) {
            this.handleExit()
            this.resetFilter()
            this.getUrlList()
          } else {
            this.$message.error(result['err_msg'])
            // this.dialogVisible = false
          }
          this.submitloading = false
        }
      })
    },
    handleExit () {
      this.dialogVisible = false
    },
    async getUrlList (params = {}) {
      this.loading = true
      let result = await Mp.System.ShortUrlGetList(this.filter)
      this.tableData = result['data']['list']
      this.total = result['data']['count']
      this.loading = false
    }
  },
  created () {
    this.queryToFilter()
    // this.getTagList()
    // this.getUrlList()
  }
}
</script>

<style scoped>
</style>
